import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlSignature } from '../common/apiEndpoint';
import { certificate } from './certificate';

@Injectable()
export class ExaminationService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getCertificates(personId: string): Observable<certificate[]> {
    const url = this.urlSignature.certificatesUrl + '/' + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as certificate[]));
  }
}
